import { Route } from "react-router-dom";
import ProviderAddTicket from "../components/ProviderAddTicket";
import ProviderTicketList from "../components/ProviderTicketList";

import ProviderMiddleware from "../../provider-middleware/components";

const ProviderTicketRoutes = () => (
  <>
    <Route path="tickets" element={<ProviderMiddleware><ProviderTicketList /></ProviderMiddleware>} />
    <Route path="add-ticket" element={<ProviderMiddleware><ProviderAddTicket /></ProviderMiddleware>} />
  </>
);


export default ProviderTicketRoutes;